module.exports = __webpack_public_path__ + "img/zhiyuan.067bfbd2.png";